import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import NoticeModal from "views/components/NoticeModal";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import FindStructureData from "helper/FindStructureType";
const RoleCreate = ({ props, classes }) => {
  const navigate = useNavigate();
  const params = useParams();
  const [role, setRole] = useState(params.roleId ? params.roleId : "");
  const [roleState, setRoleState] = useState(false);
  const [name, setName] = useState("");
  const [nameState, setNameState] = useState(false);
  const [masterTypeId, setMasterTypeId] = useState("");
  const [masterTypeIdState, setMasterTypeIdState] = useState("");
  const [canReadUser, setCanReadUser] = useState(false);
  const [canCreateUser, setCanCreateUser] = useState(false);

  const [canUpdateUser, setCanUpdateUser] = useState(false);
  const [canDeleteUser, setCanDeleteUser] = useState(false);
  const [rawDataDataRole, setRawDataRole] = useState({});

  const [noticeModal, setNoticeModal] = useState(false);
  const [noticeModalErrMsg, setNoticeModalErrMsg] = useState("");
  const [noticeModalHeaderMsg, setNoticeModalHeaderMsg] = useState("");
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [masterTypeList, setMasterTypeList] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      if (params.roleId) {
        setCallInProgress(true);
        // Get Data from API
        const roleDetails = await apiHandler({
          url: endpoint.MASTER_ROLE_FIND + "?role=" + params.roleId,
          authToken: authToken,
        });
        setCallInProgress(false);
        setRawDataRole(roleDetails.data[0]);
        setRole(roleDetails.data[0].role);
        setName(roleDetails.data[0].name);
      }
    })();
  }, []);
  useEffect(() => {
    if (rawDataDataRole.masterTypeCode) {
      const structureType = masterTypeList.filter(
        (z) => z.code === rawDataDataRole.masterTypeCode
      );
      if (structureType.length > 0) {
        setMasterTypeId(structureType[0].code);
        setMasterTypeIdState("success");
      }
    }
  }, [masterTypeList]);
  useEffect(() => {
      FindStructureData(
        apiHandler,
        endpoint,
        authToken,
        setMasterTypeList
      );
   
  }, []);
  // message popup
  const closeNoticeModal = () => {
    setNoticeModal(false);
    setNoticeModalErrMsg("");
    setNoticeModalHeaderMsg("");
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const isValidated = () => {
    if (role === "") {
      setRoleState(true);
    } else {
      setRoleState(false);
    }
    if (name === "") {
      setNameState(true);
    } else {
      setNameState(false);
    }
    if (role && name) {
      return true;
    } else {
      return false;
    }
  };
  const editRoleInformation = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.MASTER_ROLE_UPDATE,
      method: "PUT",
      authToken: authToken,
      data: {
        role: role,
        name: name,
        // masterTypeId: masterTypeId,
        canReadUser: canReadUser,
        canCreateUser: canCreateUser,
        canUpdateUser: canUpdateUser,
        canDeleteUser: canDeleteUser,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      setNoticeModalErrMsg(res?.data?.user_description);
      setNoticeModalHeaderMsg("Error");
      setNoticeModal(true);
      return "ERROR";
    } else {
      return "SUCCESS";
    }
  };
  const saveRoleInformation = async () => {
    setCallInProgress(true);
    const bulkData = {
      role: role,
      name: name,
      // masterTypeId: masterTypeId,
      canReadUser: canReadUser,
      canCreateUser: canCreateUser,
      canUpdateUser: canUpdateUser,
      canDeleteUser: canDeleteUser,
    };
    const res = await apiHandler({
      url: endpoint.MASTER_ROLE_ADD,
      method: "POST",
      authToken: authToken,
      data: bulkData,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      setNoticeModalErrMsg(res?.data?.user_description);
      setNoticeModalHeaderMsg("Error");
      setNoticeModal(true);
      return "ERROR";
    } else {
      return "SUCCESS";
    }
  };
  const handleroleSubmit = async (event) => {
    if (isValidated()) {
      setNoticeModal(false);
      setNoticeModalErrMsg("");
      setNoticeModalHeaderMsg("");
      let status = "";
      if (params.roleId) {
        status = await editRoleInformation();
      } else {
        status = await saveRoleInformation();
      }
      if (status === "SUCCESS") {
        const msg = params.roleId
          ? "Role updated successfully!"
          : "Role created successfully!";
        setNoticeModalErrMsg(msg);
        setNoticeModalHeaderMsg("Information");
        setNoticeModal(true);
        setRedirectURL(`/coreservice/roles`);
      }
    }
  };
  const handlecancelrole = () => {
    navigate("/coreservice/roles");
  };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={params.roleId ? "Edit Role" : "Create Role"}
          button1=" Save"
          button2=" Cancel"
          button1click={handleroleSubmit}
          button2click={handlecancelrole}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Role"
              required
              error={roleState}
              id="lp_min_role"
              value={role || ""}
              setState={setRole}
              disabled
              setError={setRoleState}
            />
          </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Role Name"
              required
              error={nameState}
              id="lp_min_role_name"
              value={name || ""}
              setState={setName}
              setError={setNameState}
            />
          </Grid>
        </Grid>
      </Grid>
      <NoticeModal
        noticeModal={noticeModal}
        noticeModalHeader={noticeModalHeaderMsg}
        noticeModalErrMsg={noticeModalErrMsg}
        closeModal={closeNoticeModal}
      />

      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default RoleCreate;
